<script setup lang="ts">
const storeIndex = useStoreIndex()
</script>

<template>
  <div class="c-navigateBar">
    <ClientOnly>
      <v-breadcrumbs
        v-bind:items="storeIndex.state.breadCrumbsItems"
        divider=">"
      />
    </ClientOnly>
  </div>
</template>

<style lang="scss" scoped>
@use "@/assets/css/foundation/mixin/responsive";

.c-navigateBar {
  display: flex;
  align-content: center;
  justify-content: center;
  width: 100%;
  min-height: 48px;
  background-color: white;

  :deep(.v-breadcrumbs) {
    width: 100%;
    max-width: var(--g_max_content_width);
    padding: 15px 0;
    display: flex;
    flex-wrap: wrap;

    li {
      color: var(--color_text_base);
      font-size: 12px;
      line-height: 1.5;
    }

    .v-breadcrumbs-item {
      font-family: "Noto Sans JP", sans-serif;
    }

    .v-breadcrumbs-item--link {
      color: var(--color_text_base) !important;
    }

    .v-breadcrumbs-divider {
      padding: 0 4px !important;
    }

    @include responsive.mq_down(sp) {
      height: auto;
    }
  }
}
</style>
